import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=70fb53f2"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"
import style0 from "./Archive.vue?vue&type=style&index=0&id=70fb53f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports